module.exports = __webpack_public_path__ + "img/footer-btn_bg.2c76bac6.png";